import {Contract} from				'../../redux/contracts/interface';

function ft_getFunderFromContract(idDevice: string, contract: Contract) {
	if (!contract)
		return;
	return contract.funderList.find(find => find?.devices?.find(device => device.device._id === idDevice));
}

export {ft_getFunderFromContract};